"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconUndo = function SvgIconUndo(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "undo icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Undo Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37.3 11.017H11.196L11.116 6H40a4 4 0 014 4v20.023a4 4 0 01-4 4H12.988l4.687 4.687-3.295 3.342L4 31.672l10.38-10.379 3.295 3.343-4.687 4.686h24.311a2 2 0 002-2V13.017a2 2 0 00-2-2z"
  }));
};

var _default = SvgIconUndo;
exports.default = _default;